/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import I18n from 'components/Translate/I18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import Alert from 'react-bootstrap-sweetalert';
import PropTypes from 'prop-types';

class AlertConfirm extends PureComponent {
    render() {
        const { onConfirm, onCancel, confirmParams = {}, confirmBtnText, cancelBtnText, content, valueObject } = this.props;
        return (
            <Alert
                warning
                title=""
                style={{ display: 'block' }}
                onConfirm={() => onConfirm(confirmParams)}
                onCancel={onCancel}
                confirmBtnText={<I18n trans={confirmBtnText} />}
                cancelBtnText={<I18n trans={cancelBtnText} />}
                confirmBtnCssClass={this.props.classes.button + ' ' + this.props.classes.success}
                cancelBtnCssClass={this.props.classes.button + ' ' + this.props.classes.warning}
                showCancel
            >
                {typeof content === 'string' && (
                    <Typography variant="subtitle2">
                        <I18n trans={content} valueObject={valueObject} />
                    </Typography>
                )}

                {typeof content !== 'string' && content}
            </Alert>
        );
    }
}

AlertConfirm.propTypes = {
    classes: PropTypes.object.isRequired,
    onConfirm: PropTypes.func.isRequired,
    confirmParams: PropTypes.object,
    confirmBtnText: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired | PropTypes.element.isRequired,
    onCancel: PropTypes.func,
    valueObject: PropTypes.string,
    cancelBtnText: PropTypes.string,
};

export default withStyles(adescomStyle)(AlertConfirm);
